// Identidade do bundle atual e leitura da identidade publicada pelo servidor.
// Falhar em rede é normal e nunca pode derrubar o app.
export const BUILD_ID: string = typeof __BUILD_ID__ === "string" ? __BUILD_ID__ : "dev";
export const VERSION_ENDPOINT = "/version.json";

export async function fetchDeployedBuildId(signal?: AbortSignal): Promise<string | null> {
  try {
    const response = await fetch(`${VERSION_ENDPOINT}?t=${Date.now()}`, {
      cache: "no-store",
      signal,
    });
    if (!response.ok) return null;
    const data = (await response.json()) as { buildId?: unknown };
    return typeof data.buildId === "string" && data.buildId.length > 0 ? data.buildId : null;
  } catch {
    return null;
  }
}
